import React from 'react';
import {Box, styled} from '@mui/material';
import {
  designSystemToken,
  Label,
  Tooltip,
} from '@lightricks/react-design-system';
import Pagination from '@contentlab/components/pagination';
import ConfigButton from '@contentlab/views/contentlab/pages/ai-avatar-page/components/config-button';
import translate from '@/utils/translate';

const HeaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  paddingTop: '11px',
}));

const LeftSection = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
}));

interface SuggestedScriptHeaderProps {
  testID?: string;
  currentIndex: number;
  totalScripts: number;
  onNavigate: (page: number) => void;
  onCustomize: () => void;
}

function SuggestedScriptHeader({
  testID = 'suggested-script-header',
  currentIndex,
  totalScripts,
  onNavigate,
  onCustomize,
}: SuggestedScriptHeaderProps) {
  return (
    <HeaderContainer data-testid={testID}>
      <LeftSection>
        <Label size="lg" color={designSystemToken('semantic.fg.primary')}>
          {translate('Select script')}
        </Label>
        <Pagination
          testID={`${testID}-pagination`}
          page={currentIndex + 1}
          count={totalScripts}
          handleOnChange={(nextPage) => {
            const pageIndex = nextPage - 1;
            onNavigate(pageIndex);
          }}
          disabled={totalScripts <= 1}
          size="small"
        />
      </LeftSection>

      <Tooltip
        title={translate(
          "Customize the voiceover script's purpose, audience, and style."
        )}
        arrow
        placement="top"
        sx={{
          '.MuiTooltip-tooltip': {
            padding: '12px',
            textAlign: 'center',
            whiteSpace: 'pre-wrap',
            fontSize: '14px',
            color: designSystemToken('semantic.fg.primary'),
          },
        }}
      >
        <Box>
          <ConfigButton
            onClick={onCustomize}
            data-testid={`${testID}-customize-button`}
            hideIcon
          >
            {translate('Smart Edit')}
          </ConfigButton>
        </Box>
      </Tooltip>
    </HeaderContainer>
  );
}

export default SuggestedScriptHeader;
